import type { DocumentTemplateVersionDetailPayload } from '@Application/Documents/Templates/Actions/documentTemplateVersionFetched';

// The `201` response is the created version, with its declaration — same shape as the first
// deposit's response.
export type DocumentTemplateVersionUploadedPayload = DocumentTemplateVersionDetailPayload;

export type DocumentTemplateVersionUploadedAction = {
	type: 'DOCUMENT_TEMPLATE_VERSION_UPLOADED';
	payload: DocumentTemplateVersionUploadedPayload;
};

export default (payload: DocumentTemplateVersionUploadedPayload): DocumentTemplateVersionUploadedAction => ({
	type: 'DOCUMENT_TEMPLATE_VERSION_UPLOADED',
	payload,
});
